import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCrossProductParams,
  clearParams,
} from '@stores/crossProductAction';
import { Signatory } from '@src/stores/signatures/signature-wizard/interfaces/signatory-form-value';
import { sendInternalAnalytics } from '@utils/analytics';

interface CrossProductExecutionResult {
  shouldOpenDrawer: boolean;
  preloadedSignatory: Partial<Signatory> | undefined;
  onDrawerClose: () => void;
}

export function useCrossProductExecution(): CrossProductExecutionResult {
  const dispatch = useDispatch();
  const crossProductParams = useSelector(selectCrossProductParams);
  const executedRef = useRef(false);

  const [shouldOpenDrawer, setShouldOpenDrawer] = useState(false);
  const [preloadedSignatory, setPreloadedSignatory] =
    useState<Partial<Signatory>>();

  useEffect(() => {
    if (!crossProductParams) return;
    if (executedRef.current) return;

    executedRef.current = true;

    const signatory: Partial<Signatory> = {};
    if (crossProductParams.doc) {
      signatory.document = crossProductParams.doc;
    }
    if (crossProductParams.name) {
      signatory.name = crossProductParams.name;
    }
    if (crossProductParams.email) {
      signatory.email = crossProductParams.email;
    }
    if (crossProductParams.phoneNumber) {
      signatory.phone = crossProductParams.phoneNumber;
    }

    setPreloadedSignatory(signatory);
    setShouldOpenDrawer(true);
    dispatch(clearParams());

    sendInternalAnalytics({
      eventCategory: '[CROSS PRODUCT][AUTO ACTION]',
      eventAction: '[EXECUTAR][ENVELOPE]',
      eventLabel: 'assinaturas',
    });
  }, [crossProductParams, dispatch]);

  const onDrawerClose = () => {
    setShouldOpenDrawer(false);
    setPreloadedSignatory(undefined);
  };

  return { shouldOpenDrawer, preloadedSignatory, onDrawerClose };
}
